(function () {
  'use strict';

  function initShippingCalculator() {
    const calculators = document.querySelectorAll('[data-shipping-calculator]');

    calculators.forEach((calculator) => {
      if (calculator.dataset.shippingInitialized === 'true') return;
      calculator.dataset.shippingInitialized = 'true';

      const sectionId = calculator.dataset.shippingCalculator;
      const input = calculator.querySelector('.ec-shipping-calculator__input');
      const calculateBtn = calculator.querySelector('[data-shipping-calculate-btn]');
      const messageEl = calculator.querySelector('[data-shipping-message]');
      const resultsEl = calculator.querySelector('[data-shipping-results]');
      const resultsListEl = calculator.querySelector('[data-shipping-results-list]');

      if (!input || !calculateBtn || !messageEl || !resultsEl || !resultsListEl) return;

      input.addEventListener('input', function (e) {
        let value = e.target.value.replace(/\D/g, '');
        if (value.length > 5) {
          value = value.substring(0, 5) + '-' + value.substring(5, 8);
        }
        e.target.value = value;
      });

      input.addEventListener('keypress', function (e) {
        if (e.key === 'Enter') {
          e.preventDefault();
          calculateBtn.click();
        }
      });

      calculateBtn.addEventListener('click', async function () {
        const cep = input.value.replace(/\D/g, '');

        if (cep.length !== 8) {
          showMessage(messageEl, 'Por favor, digite um CEP válido', 'error');
          return;
        }

        calculateBtn.disabled = true;
        showMessage(messageEl, 'Calculando frete...', 'loading');
        resultsEl.style.display = 'none';

        try {
          const shippingOptions = await calculateShipping(cep, sectionId, calculator);

          if (!shippingOptions || shippingOptions.length === 0) {
            showMessage(messageEl, 'Não encontramos opções de frete para este CEP.', 'error');
            calculateBtn.disabled = false;
            return;
          }

          displayShippingResults(resultsListEl, shippingOptions);
          showMessage(messageEl, '', '');
          resultsEl.style.display = 'block';
        } catch (error) {
          showMessage(messageEl, 'Erro ao calcular frete. Tente novamente.', 'error');
        } finally {
          calculateBtn.disabled = false;
        }
      });
    });
  }

  async function fetchAddressByCEP(cep) {
    try {
      const response = await fetch(`https://viacep.com.br/ws/${cep}/json/`);
      if (!response.ok) throw new Error('Erro ao buscar CEP');
      return await response.json();
    } catch (error) {
      return null;
    }
  }

  function getVariantId(sectionId, calculator) {
    const variantFromData = calculator?.dataset?.variantId;
    if (variantFromData) return variantFromData;

    if (sectionId) {
      const productInfo = document.querySelector(`product-info[data-section="${sectionId}"]`);
      const input = productInfo?.querySelector('input[name="id"]');
      if (input?.value) return input.value;
    }

    const formInput = document.querySelector(
      `#MainProduct-${sectionId} input[name="id"], form[action="/cart/add"] input[name="id"], product-form input[name="id"]`
    );
    return formInput?.value || null;
  }

  async function resolveAvailableVariant(currentVariantId) {
    try {
      const pathParts = window.location.pathname.split('/');
      const productsIndex = pathParts.indexOf('products');
      const handle = productsIndex !== -1 ? pathParts[productsIndex + 1] : null;

      if (handle) {
        const res = await fetch(`/products/${handle}.js`, { credentials: 'same-origin' });
        if (res.ok) {
          const product = await res.json();
          const available = (product.variants || []).find((v) => v.available);
          if (available) return available.id;
        }
      }

      const catalogRes = await fetch('/products.json?limit=10&sort_by=created-descending', { credentials: 'same-origin' });
      if (catalogRes.ok) {
        const catalog = await catalogRes.json();
        for (const p of catalog.products || []) {
          const availableVariant = (p.variants || []).find((v) => v.available);
          if (availableVariant) return availableVariant.id;
        }
      }
    } catch (e) {
      // silently fall through
    }

    return null;
  }

  async function calculateShipping(cep, sectionId, calculator) {
    const zipCode = cep.replace(/\D/g, '');

    if (zipCode.length !== 8) {
      throw new Error('CEP inválido');
    }

    const formattedZip = zipCode.slice(0, 5) + '-' + zipCode.slice(5);
    const currentVariantId = getVariantId(sectionId, calculator);

    const pathParts = window.location.pathname.split('/');
    const productsIdx = pathParts.indexOf('products');
    const handle = productsIdx !== -1 ? pathParts[productsIdx + 1] : null;

    let [addressData, cart, prefetchedProduct] = await Promise.all([
      fetchAddressByCEP(zipCode),
      fetch('/cart.js', { credentials: 'same-origin' })
        .then((r) => r.ok ? r.json() : { items: [] })
        .then((c) => { if (!Array.isArray(c.items)) c.items = []; return c; })
        .catch(() => ({ items: [] })),
      handle
        ? fetch(`/products/${handle}.js`, { credentials: 'same-origin' })
            .then((r) => r.ok ? r.json() : null)
            .catch(() => null)
        : Promise.resolve(null),
    ]);

    const province = addressData?.uf || '';
    const city = addressData?.localidade || '';
    const streetName = addressData?.logradouro || '';
    const neighborhood = addressData?.bairro || '';

    const wordJoiner = '⁠';
    const concatenatedAddress1 = streetName ? `${streetName}${wordJoiner}` : '';
    const concatenatedAddress2 = neighborhood ? `${wordJoiner}${neighborhood}` : '';

    let itemKey = null;
    let needsCleanup = false;

    if (currentVariantId) {
      const existingItem = cart.items.find(
        (item) => item.variant_id.toString() === currentVariantId.toString()
      );

      if (!existingItem) {
        let variantToAdd = null;
        if (prefetchedProduct) {
          const available = (prefetchedProduct.variants || []).find((v) => v.available);
          if (available) variantToAdd = available.id;
        }
        if (!variantToAdd) {
          variantToAdd = await resolveAvailableVariant(currentVariantId);
        }

        if (variantToAdd) {
          try {
            const addResponse = await fetch('/cart/add.js', {
              method: 'POST',
              credentials: 'same-origin',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ id: variantToAdd, quantity: 1 }),
            });

            if (addResponse.ok) {
              const updatedCartResponse = await fetch('/cart.js', { credentials: 'same-origin' });
              if (updatedCartResponse.ok) {
                const updatedCart = await updatedCartResponse.json();
                const items = Array.isArray(updatedCart.items) ? updatedCart.items : [];
                const newItem = items.find(
                  (item) => item.variant_id.toString() === variantToAdd.toString()
                );
                if (newItem) {
                  itemKey = newItem.key;
                  needsCleanup = true;
                  cart = updatedCart;
                }
              }
            }
          } catch (e) {
            // silently fall through
          }
        }
      }
    }

    const addressDataForCart = {
      name: '',
      lastName: '',
      address1: concatenatedAddress1,
      streetName: streetName,
      streetNumber: '',
      address2: concatenatedAddress2,
      line2: '',
      neighborhood: neighborhood,
      city: city,
      zoneCode: province,
      postalCode: formattedZip,
      countryCode: 'BR',
      oneTimeUse: false,
    };

    await fetch('/cart/update.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        attributes: {
          _shipping_address: JSON.stringify(addressDataForCart),
        },
      }),
    });

    const shippingParams = new URLSearchParams({
      'shipping_address[zip]': formattedZip,
      'shipping_address[country]': 'BR',
    });

    const fetchShippingRates = async (params) => {
      const response = await fetch(`/cart/shipping_rates.json?${params.toString()}`, { credentials: 'same-origin' });
      if (!response.ok) return { shipping_rates: [] };
      return response.json();
    };

    let shippingData = await fetchShippingRates(shippingParams);

    if ((!shippingData.shipping_rates || shippingData.shipping_rates.length === 0) && addressData) {
      if (province) shippingParams.set('shipping_address[province]', province);
      if (city) shippingParams.set('shipping_address[city]', city);
      if (concatenatedAddress1) shippingParams.set('shipping_address[address1]', concatenatedAddress1);
      if (concatenatedAddress2) shippingParams.set('shipping_address[address2]', concatenatedAddress2);
      if (streetName) shippingParams.set('shipping_address[street_name]', streetName);
      if (neighborhood) shippingParams.set('shipping_address[neighborhood]', neighborhood);

      shippingData = await fetchShippingRates(shippingParams);
    }

    if (needsCleanup && itemKey) {
      fetch('/cart/change.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: itemKey, quantity: 0 }),
      });
    }

    if (!shippingData.shipping_rates || shippingData.shipping_rates.length === 0) {
      return [];
    }

    const addBusinessDays = (startDate, days) => {
      const result = new Date(startDate);
      let added = 0;
      while (added < days) {
        result.setDate(result.getDate() + 1);
        const dow = result.getDay();
        if (dow !== 0 && dow !== 6) added++;
      }
      return result;
    };

    const formatShortDate = (date) =>
      date.toLocaleDateString('pt-BR', { day: '2-digit', month: '2-digit' });

    return shippingData.shipping_rates.map((rate) => {
      const price = parseFloat(rate.price) || 0;
      const priceInCents = Math.round(price * 100);

      let timeText = 'Prazo a confirmar';
      let deliveryDateText = null;

      const today = new Date();
      today.setHours(0, 0, 0, 0);

      const extractDays = (str) => {
        if (!str) return null;
        const match = str.match(/(\d+)\s*dias?\s*úteis?/i);
        return match ? parseInt(match[1], 10) : null;
      };

      if (rate.delivery_days && Array.isArray(rate.delivery_days) && rate.delivery_days.length > 0) {
        const minDays = rate.delivery_days[0] || 0;
        const maxDays = rate.delivery_days[1] || minDays;

        if (minDays === maxDays && minDays > 0) {
          timeText = `${minDays} ${minDays !== 1 ? 'dias úteis' : 'dia útil'}`;
          deliveryDateText = formatShortDate(addBusinessDays(today, maxDays));
        } else if (minDays > 0) {
          timeText = `${minDays} a ${maxDays} dias úteis`;
          deliveryDateText = formatShortDate(addBusinessDays(today, maxDays));
        }
      } else if (rate.delivery_range) {
        if (rate.delivery_range.min && rate.delivery_range.max) {
          const maxDate = new Date(rate.delivery_range.max);
          const diffDays = Math.ceil((maxDate - today) / (1000 * 60 * 60 * 24));
          if (diffDays > 0) {
            timeText = `Em até ${diffDays} ${diffDays !== 1 ? 'dias úteis' : 'dia útil'}`;
            deliveryDateText = formatShortDate(maxDate);
          }
        }
      } else if (rate.delivery_date) {
        const deliveryDate = new Date(rate.delivery_date);
        const diffDays = Math.ceil((deliveryDate - today) / (1000 * 60 * 60 * 24));
        if (diffDays > 0) {
          timeText = `Em até ${diffDays} ${diffDays !== 1 ? 'dias úteis' : 'dia útil'}`;
          deliveryDateText = formatShortDate(deliveryDate);
        }
      } else {
        const days = extractDays(rate.name) || extractDays(rate.description);
        if (days && days > 0) {
          timeText = `${days} ${days !== 1 ? 'dias úteis' : 'dia útil'}`;
          deliveryDateText = formatShortDate(addBusinessDays(today, days));
        }
      }

      return {
        name: rate.name || rate.description || 'Frete',
        time: timeText,
        deliveryDate: deliveryDateText,
        price: priceInCents,
        available: true,
      };
    });
  }

  function displayShippingResults(resultsListEl, shippingOptions) {
    resultsListEl.innerHTML = '';
    const compact = !!resultsListEl.closest('[data-shipping-compact]');

    shippingOptions.forEach((option, index) => {
      const optionEl = document.createElement('div');
      optionEl.className = `ec-shipping-option ${option.price === 0 ? 'ec-shipping-option--free' : ''} ${!option.available ? 'ec-shipping-option--unavailable' : ''}`;

      const priceText =
        option.price === 0
          ? 'Grátis'
          : new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(
              option.price / 100
            );

      optionEl.innerHTML = `
        <span class="ec-shipping-option__name">${option.name}</span>
        <span class="ec-shipping-option__time">${
          compact
            ? (option.deliveryDate ? `Até ${option.deliveryDate}` : option.time)
            : `Prazo estimado: ${option.time}${option.deliveryDate ? ` - até ${option.deliveryDate}` : ''}`
        }</span>
        <span class="ec-shipping-option__price">${priceText}</span>
      `;

      resultsListEl.appendChild(optionEl);

      if (index < shippingOptions.length - 1) {
        const divider = document.createElement('div');
        divider.className = 'ec-shipping-option__divider';
        resultsListEl.appendChild(divider);
      }
    });
  }

  function showMessage(messageEl, text, type) {
    if (!messageEl) return;

    messageEl.textContent = text;
    messageEl.className = 'ec-shipping-calculator__message';

    if (type) {
      messageEl.classList.add(`ec-shipping-calculator__message--${type}`);
    }
  }

  if (!window.__EC_PRODUCT_SHIPPING_CALC_OBSERVED) {
    window.__EC_PRODUCT_SHIPPING_CALC_OBSERVED = true;
    const observer = new MutationObserver(() => {
      initShippingCalculator();
    });
    observer.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initShippingCalculator);
  } else {
    initShippingCalculator();
  }
})();
